<div class="filters-bar">
    <form [formGroup]="filterForm">
        <div class="filter-form-container" align="center">
            <mat-form-field class="form-item search-term height-36 without-label without-error">
                <fa-icon matPrefix class="mat-accent search-icon" [icon]="faMagnifyingGlass"></fa-icon>
                <input matInput tabindex="1" placeholder="Terme à rechercher" formControlName="searchControl" autocomplete="off" />
                <mat-error>InvalidSearchTerm</mat-error>
            </mat-form-field>
            <div class="buttons">
                <button mat-stroked-button class="primary-button button-launch-search" tabindex="4" (click)="onSearch()">Lancer la recherche</button>
                <button
                    mat-fab
                    class="primary-button height-36 button-erase-filter"
                    aria-label="Réinitialiser"
                    matTooltip="Réinitialiser"
                    matTooltipPosition="below"
                    (click)="onUndo()">
                    <fa-icon [icon]="resetFilterIcon"></fa-icon>
                </button>

                <button
                    mat-fab
                    class="primary-button height-36 button-erase-filter"
                    aria-label="Filtrer..."
                    matTooltip="Filtrer..."
                    matTooltipPosition="below"
                    [matMenuTriggerFor]="filterMenu">
                    <fa-icon [icon]="filterIcon"></fa-icon>
                </button>
            </div>

            <mat-menu #filterMenu="matMenu" class="filters-menu">
                <div class="filter-menu">
                    @if (selectedColumns.length > 0) {
                        <div>
                            <p class="menu-title">Supprimer un filtre</p>
                            @for (selectedColumn of selectedColumns; track selectedColumn) {
                                <div class="menu-item">
                                    <mat-checkbox class="primary-button" checked="true" (change)="onUnfilteredColumnChage(selectedColumn)">
                                        {{ selectedColumn.headerText }}
                                    </mat-checkbox>
                                </div>
                            }
                        </div>
                    }
                    @if (columnList.length > 0) {
                        <div>
                            <p class="menu-title">Sélectionner un filtre</p>
                            @for (column of columnList; track column) {
                                <div class="menu-item">
                                    <mat-checkbox (change)="onFilteredColumnChange(column)">{{ column.headerText }}</mat-checkbox>
                                </div>
                            }
                        </div>
                    }
                </div>
            </mat-menu>

            @for (filter of selectedColumns; track filter) {
                <mat-chip-set>
                    <button #filterChip class="selected-filter-container" [matMenuTriggerFor]="chipMenu">
                        <mat-chip
                            (removed)="removeFilter(filter)"
                            [matTooltip]="
                                isDateInput(filter)
                                    ? (filterHandler.filtersForm.get(filter.columnName)?.value | AvmDate)
                                    : isDateAndTimeInput(filter)
                                      ? (filterHandler.filtersForm.get(filter.columnName)?.value | AvmDateAndTime)
                                      : (filter | avmFilterSubstring: filterHandler.filtersForm.get(filter.columnName)?.value : 150)
                            ">
                            @if (!isDateInput(filter) && !isDateAndTimeInput(filter)) {
                                <span>{{ filter.headerText }}: {{ filter | avmFilterSubstring: filterHandler.filtersForm.get(filter.columnName)?.value }}</span>
                            }
                            @if (isDateInput(filter)) {
                                <span>{{ filter.headerText }}: {{ filterHandler.filtersForm.get(filter.columnName)?.value | AvmDate }}</span>
                            }
                            <mat-icon>expand_more</mat-icon>
                            <mat-menu style="visibility: hidden" class="selected-filter-edit-container" #chipMenu="matMenu">
                                <form [formGroup]="filterHandler.filtersForm" novalidate>
                                    <div (click)="$event.stopPropagation()">
                                        @if (!isListInput(filter) && !isBooleanInput(filter)) {
                                            <mat-form-field
                                                class="height-36 without-error"
                                                [ngClass]="{ 'active-filter': !!filterHandler.filterValues[filter.columnName], 'mat-form-field-date-filter': isDateInput(filter) }">
                                                @if (isStandardInput(filter)) {
                                                    <input
                                                        matInput
                                                        [formControlName]="filter.columnName"
                                                        [placeholder]="filter.headerText"
                                                        autocomplete="off"
                                                        (click)="$event.stopPropagation()" />
                                                }
                                                @if (isDateInput(filter)) {
                                                    <input
                                                        matInput
                                                        tabindex="3"
                                                        [matDatepicker]="i"
                                                        [formControlName]="filter.columnName"
                                                        [placeholder]="filter.headerText"
                                                        class="date-filter-input"
                                                        autocomplete="off" />
                                                }
                                                <mat-datepicker-toggle matSuffix [for]="i" [hidden]="!isDateInput(filter)"></mat-datepicker-toggle>
                                                <mat-datepicker #i [hidden]="!isDateInput(filter)"></mat-datepicker>
                                            </mat-form-field>
                                        }
                                        @if (isListInput(filter) && filter.columnName !== 'boxId') {
                                            <mat-selection-list class="primary-button list-selection" [formControlName]="filter.columnName">
                                                @for (item of getValues2(filter); track item) {
                                                    <mat-list-option [value]="item.value" checkboxPosition="before">{{ item.text }}</mat-list-option>
                                                }
                                            </mat-selection-list>
                                        }
                                        @if (isBooleanInput(filter)) {
                                            <mat-checkbox [formControlName]="filter.columnName" (click)="$event.stopPropagation()">{{ filter.headerText }}</mat-checkbox>
                                        }
                                    </div>
                                </form>
                            </mat-menu>
                            <mat-icon matChipRemove>cancel</mat-icon>
                        </mat-chip>
                    </button>
                </mat-chip-set>
            }
        </div>
    </form>
</div>
